var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgForward = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563",
    transform: "translate(-563.123 -186)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(563.123 186)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Share_1522445",
    transform: "translate(567.881 191.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4563-2",
    "data-name": "Group 4563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M18.046,11.427l-5.352-3.9L12.7,9.367c-.158.047-.314.1-.469.151a7.9,7.9,0,0,0-3.9,2.9,7.253,7.253,0,0,0-1.2,2.736,6.646,6.646,0,0,0,.021,2.762A6.053,6.053,0,0,1,8.2,15.609a5.12,5.12,0,0,1,4.519-2.1l.009,1.893Z",
    transform: "translate(-7 -7.524)",
    fill: "#9d9d9d"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/forward.fb3eca5b.svg";
export { ForwardRef as ReactComponent };